import { KairosService } from '../services/kairos.service';
import { ListadoKairos } from '../models/listadoKairos';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
var KairosComponent = /** @class */ (function () {
    function KairosComponent(kairosService, router, authService) {
        this.kairosService = kairosService;
        this.router = router;
        this.authService = authService;
        this.pagina = 0;
        this.cantidadPorPagina = 20;
        this.listado = null;
        this.paginas = 0;
        this.isLoading = true;
        this.display = false;
        this.esAdmin = false;
        this.kairos = null;
        this.alert = {
            tipo: "success",
            titulo: "",
            mensaje: "",
            visible: false
        };
        this.listado = new ListadoKairos();
        this.listado.kairos = new Array();
        this.esAdmin = this.authService.roles.indexOf("administrador") > -1;
    }
    KairosComponent.prototype.ngOnInit = function () {
        this.obtenerListado();
    };
    KairosComponent.prototype.obtenerListado = function (paginaActual) {
        var _this = this;
        this.pagina = paginaActual == null ? 0 : paginaActual;
        this.spinner.isRunning = true;
        this.kairosService.listado(this.pagina, this.cantidadPorPagina).subscribe(function (result) {
            _this.spinner.isRunning = false;
            _this.listado = result;
            if (_this.listado && _this.listado.total > 0) {
                _this.paginas = Math.floor((_this.listado.total + _this.cantidadPorPagina - 1) / _this.cantidadPorPagina);
            }
        });
    };
    KairosComponent.prototype.anterior = function () {
        this.obtenerListado(this.pagina - 1);
    };
    KairosComponent.prototype.siguiente = function () {
        this.obtenerListado(this.pagina + 1);
    };
    KairosComponent.prototype.paginate = function (event) {
        //event.first = Index of the first record
        //event.rows = Number of rows to display in new page
        //event.page = Index of the new page
        //event.pageCount = Total number of pages
        this.obtenerListado(event.page);
    };
    KairosComponent.prototype.showDialog = function (kairos) {
        this.kairos = kairos;
        this.display = true;
    };
    KairosComponent.prototype.eliminar = function () {
        var _this = this;
        this.display = false;
        this.spinner.isRunning = true;
        this.kairosService.eliminar(this.kairos.id).subscribe(function (result) {
            _this.alert.visible = true;
            _this.alert.titulo = "Eliminar archivo";
            if (result.status == 204) {
                _this.alert.tipo = "success";
                _this.alert.mensaje = "El archivo se ha eliminado correctamente";
            }
            else {
                _this.alert.tipo = "danger";
                _this.alert.mensaje = "El archivo no se ha podido eliminar. Por favor vuelva a intentarlo.";
            }
            _this.alertComponent.setType(_this.alert.tipo);
            _this.listado.kairos = _this.listado.kairos.filter(function (u) {
                return u.id != _this.kairos.id;
            });
            _this.kairos = null;
            _this.spinner.isRunning = false;
        }, function (error) {
            _this.spinner.isRunning = false;
            _this.alert.visible = true;
            _this.alert.titulo = "Eliminar archivo";
            _this.alert.tipo = "danger";
            _this.alertComponent.setType(_this.alert.tipo);
            _this.alert.mensaje = "El archivo no se ha podido eliminar. Por favor vuelva a intentarlo.";
        });
    };
    KairosComponent.ctorParameters = function () { return [{ type: KairosService }, { type: Router }, { type: AuthService }]; };
    return KairosComponent;
}());
export { KairosComponent };
//# sourceMappingURL=kairos.component.js.map


// WEBPACK FOOTER //
// kairos.component.js